/**
 * randomUUID — `crypto.randomUUID()` with a non-secure-context fallback.
 *
 * `crypto.randomUUID` exists only in SECURE contexts. `localhost` is
 * special-cased as secure, but the local cross-subdomain dev host
 * (http://lvh.me:3000 — the dotted host that makes sub-app cookie sharing
 * work, see docker-compose.yml) is NOT, and every create path that minted an
 * Idempotency-Key with a bare `crypto.randomUUID()` threw synchronously there
 * before the request was even sent. Older mobile webviews share the gap.
 *
 * `crypto.getRandomValues` IS available in non-secure contexts, so the
 * fallback assembles an RFC 4122 v4 UUID from it — full 122 bits of entropy,
 * same shape and uniqueness properties as the native call.
 */
export function randomUUID(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
  return (
    hex.slice(0, 4).join("") +
    "-" +
    hex.slice(4, 6).join("") +
    "-" +
    hex.slice(6, 8).join("") +
    "-" +
    hex.slice(8, 10).join("") +
    "-" +
    hex.slice(10, 16).join("")
  );
}
